/**
 * AUTO-GENERATED — do not edit manually.
 * Run `pnpm sync:tokens --overwrite` to regenerate from Figma.
 */

import { primitives } from '../../primitives'
import type { SemanticTokens } from './types'

export const darkTokens = {
  text: {
    default: primitives.neutrals.white['100'],
    onColour: primitives.neutrals.alvieBlack['100']
  },
  icons: {
    default: primitives.neutrals.white['100']
  },
  gradient: {
    fade: {
      solid: primitives.neutrals.alvieBlack['100'],
      middle: primitives.neutrals.alvieBlack['75%'],
      clear: primitives.neutrals.alvieBlack['0%']
    }
  },
  background: {
    main: {
      default: primitives.neutrals.alvieBlack['100'],
      hover: primitives.neutrals.stone['160'],
      pressed: primitives.neutrals.stone['180'],
      dragged: primitives.neutrals.stone['160'],
      selected: primitives.neutrals.stone['155'],
      focused: primitives.neutrals.alvieBlack['100'],
      disabled: primitives.neutrals.stone['180'],
      inverse: {
        default: primitives.neutrals.white['100']
      },
      tonalMedium: primitives.neutrals.stone['160'],
      tonalSoft: primitives.neutrals.stone['180'],
      accent: primitives.main.alvieBlue['90']
    },
    tonal: {
      superSoft: {
        default: primitives.neutrals.stone['180'],
        hover: primitives.neutrals.stone['155'],
        pressed: primitives.neutrals.stone['160'],
        dragged: primitives.neutrals.stone['155'],
        selected: primitives.neutrals.stone['150'],
        disabled: primitives.neutrals.stone['180'],
        focused: primitives.neutrals.stone['180'],
        inverse: {
          default: primitives.neutrals.stone['90']
        }
      },
      soft: {
        default: primitives.neutrals.stone['160'],
        hover: primitives.neutrals.stone['150'],
        pressed: primitives.neutrals.stone['155'],
        dragged: primitives.neutrals.stone['180'],
        selected: primitives.neutrals.stone['110'],
        disabled: primitives.neutrals.stone['180'],
        focused: primitives.neutrals.stone['160'],
        inverse: {
          default: primitives.neutrals.stone['100']
        }
      },
      medium: {
        default: primitives.neutrals.stone['155'],
        hover: primitives.neutrals.stone['120'],
        pressed: primitives.neutrals.stone['150'],
        dragged: primitives.neutrals.stone['120'],
        selected: primitives.neutrals.stone['100'],
        disabled: primitives.neutrals.stone['180'],
        focused: primitives.neutrals.stone['155'],
        inverse: {
          default: primitives.neutrals.stone['110']
        }
      }
    },
    overlay: {
      main: {
        default: primitives.neutrals.white['75%'],
        hover: primitives.neutrals.white['25%'],
        pressed: primitives.neutrals.white['50%'],
        dragged: primitives.neutrals.white['25%'],
        selected: primitives.neutrals.white['100'],
        disabled: primitives.neutrals.stone['180'],
        focused: primitives.neutrals.white['75%'],
        inverse: {
          default: primitives.neutrals.alvieBlack['50%']
        }
      }
    },
    brand: {
      main: {
        default: primitives.main.alvieBlue['100'],
        hover: primitives.main.alvieBlue['90'],
        pressed: primitives.main.alvieBlue['110'],
        dragged: primitives.main.alvieBlue['90'],
        selected: primitives.main.alvieBlue['60'],
        disabled: primitives.neutrals.stone['180'],
        focused: primitives.main.alvieBlue['100']
      },
      tonal: {
        superSoft: {
          default: primitives.main.alvieBlue['160'],
          hover: primitives.main.alvieBlue['120'],
          pressed: primitives.main.alvieBlue['140'],
          dragged: primitives.main.alvieBlue['120'],
          selected: primitives.main.alvieBlue['90'],
          disabled: primitives.neutrals.stone['180'],
          focused: primitives.main.alvieBlue['160'],
          inverse: primitives.semantic.info['05']
        },
        soft: {
          default: primitives.main.alvieBlue['140'],
          hover: primitives.main.alvieBlue['100'],
          pressed: primitives.main.alvieBlue['120'],
          dragged: primitives.main.alvieBlue['110'],
          selected: primitives.main.alvieBlue['60'],
          disabled: primitives.neutrals.stone['180'],
          focused: primitives.main.alvieBlue['140'],
          inverse: primitives.main.alvieBlue['20']
        },
        medium: {
          default: primitives.main.alvieBlue['120'],
          hover: primitives.main.alvieBlue['100'],
          pressed: primitives.main.alvieBlue['110'],
          dragged: primitives.main.alvieBlue['100'],
          selected: primitives.main.alvieBlue['20'],
          disabled: primitives.neutrals.stone['180'],
          focused: primitives.main.alvieBlue['120'],
          'inverse 2': primitives.main.alvieBlue['90']
        }
      }
    },
    semantic: {
      info: {
        main: {
          default: primitives.semantic.info['100'],
          hover: primitives.semantic.info['90'],
          pressed: primitives.semantic.info['110'],
          dragged: primitives.semantic.info['90'],
          selected: primitives.semantic.info['60'],
          focused: primitives.semantic.info['100'],
          disabled: primitives.neutrals.stone['180']
        },
        tonal: {
          superSoft: {
            default: primitives.semantic.info['160'],
            hover: primitives.semantic.info['120'],
            pressed: primitives.semantic.info['140'],
            dragged: primitives.semantic.info['120'],
            selected: primitives.semantic.info['90'],
            disabled: primitives.neutrals.stone['180'],
            focused: primitives.semantic.info['160'],
            inverse: primitives.semantic.info['05']
          },
          soft: {
            default: primitives.semantic.info['140'],
            hover: primitives.semantic.info['100'],
            pressed: primitives.semantic.info['120'],
            dragged: primitives.semantic.info['110'],
            selected: primitives.semantic.info['60'],
            disabled: primitives.neutrals.stone['180'],
            focused: primitives.semantic.info['140'],
            inverse: primitives.semantic.info['20']
          },
          medium: {
            default: primitives.semantic.info['120'],
            hover: primitives.semantic.info['100'],
            pressed: primitives.semantic.info['110'],
            dragged: primitives.semantic.info['100'],
            selected: primitives.semantic.info['20'],
            disabled: primitives.neutrals.stone['180'],
            focused: primitives.semantic.info['120'],
            inverse: primitives.semantic.info['90']
          }
        }
      },
      success: {
        main: {
          default: primitives.semantic.success['100'],
          hover: primitives.semantic.success['110'],
          pressed: primitives.semantic.success['90'],
          dragged: primitives.semantic.success['110'],
          selected: primitives.semantic.success['90'],
          disabled: primitives.neutrals.stone['180']
        },
        tonal: {
          superSoft: {
            default: primitives.semantic.success['160'],
            hover: primitives.semantic.success['120'],
            pressed: primitives.semantic.success['140'],
            dragged: primitives.semantic.success['120'],
            selected: primitives.semantic.success['90'],
            focused: primitives.semantic.success['160'],
            disabled: primitives.neutrals.stone['180'],
            inverse: primitives.semantic.success['05']
          },
          soft: {
            default: primitives.semantic.success['140'],
            hover: primitives.semantic.success['100'],
            pressed: primitives.semantic.success['120'],
            dragged: primitives.semantic.success['140'],
            selected: primitives.semantic.success['40'],
            focused: primitives.semantic.success['140'],
            disabled: primitives.neutrals.stone['180'],
            inverse: primitives.semantic.success['40']
          },
          medium: {
            default: primitives.semantic.success['140'],
            hover: primitives.semantic.success['160'],
            pressed: primitives.semantic.success['110'],
            dragged: primitives.semantic.success['160'],
            selected: primitives.semantic.success['20'],
            focused: primitives.semantic.success['140'],
            disabled: primitives.neutrals.stone['180'],
            inverse: primitives.semantic.success['40']
          }
        }
      },
      warning: {
        main: {
          default: primitives.semantic.warning['100'],
          hover: primitives.semantic.warning['110'],
          pressed: primitives.semantic.warning['120'],
          selected: primitives.semantic.warning['60'],
          disabled: primitives.neutrals.stone['180'],
          focused: primitives.semantic.warning['100']
        },
        tonal: {
          superSoft: {
            default: primitives.semantic.warning['160'],
            hover: primitives.semantic.warning['120'],
            pressed: primitives.semantic.warning['140'],
            dragged: primitives.semantic.warning['120'],
            selected: primitives.semantic.warning['100'],
            disabled: primitives.neutrals.stone['180'],
            focused: primitives.semantic.warning['160'],
            inverse: primitives.semantic.warning['05']
          },
          soft: {
            default: primitives.semantic.warning['140'],
            hover: primitives.semantic.warning['110'],
            pressed: primitives.semantic.warning['120'],
            dragged: primitives.neutrals.stone['180'],
            selected: primitives.semantic.warning['100'],
            disabled: primitives.neutrals.stone['180'],
            focused: primitives.semantic.warning['140'],
            inverse: primitives.semantic.warning['60']
          },
          medium: {
            default: primitives.semantic.warning['120'],
            hover: primitives.semantic.warning['100'],
            pressed: primitives.semantic.warning['110'],
            dragged: primitives.semantic.warning['100'],
            selected: primitives.semantic.warning['90'],
            disabled: primitives.neutrals.stone['180'],
            focused: primitives.semantic.warning['120'],
            inverse: primitives.semantic.warning['90']
          }
        }
      },
      error: {
        main: {
          default: primitives.semantic.error['100'],
          hover: primitives.semantic.error['110'],
          pressed: primitives.semantic.error['90'],
          selected: primitives.semantic.error['90'],
          dragged: primitives.semantic.error['110'],
          disabled: primitives.neutrals.stone['180']
        },
        tonal: {
          superSoft: {
            default: primitives.semantic.error['160'],
            hover: primitives.semantic.error['120'],
            pressed: primitives.semantic.error['140'],
            dragged: primitives.semantic.error['120'],
            selected: primitives.semantic.error['100'],
            disabled: primitives.neutrals.stone['180'],
            focused: primitives.semantic.error['160'],
            inverse: primitives.semantic.error['05']
          },
          soft: {
            default: primitives.semantic.error['140'],
            hover: primitives.semantic.error['110'],
            pressed: primitives.semantic.error['120'],
            dragged: primitives.semantic.error['110'],
            selected: primitives.semantic.error['100'],
            disabled: primitives.neutrals.stone['180'],
            focused: primitives.semantic.error['140'],
            inverse: primitives.semantic.error['40']
          },
          medium: {
            default: primitives.semantic.error['120'],
            hover: primitives.semantic.error['100'],
            pressed: primitives.semantic.error['110'],
            dragged: primitives.semantic.error['100'],
            selected: primitives.semantic.error['40'],
            disabled: primitives.neutrals.stone['180'],
            focused: primitives.semantic.error['120'],
            inverse: primitives.semantic.error['90']
          }
        }
      },
      neutral: {
        main: {
          default: primitives.neutrals.stone['155'],
          hover: primitives.neutrals.stone['160'],
          pressed: primitives.neutrals.stone['150'],
          selected: primitives.neutrals.white['100'],
          dragged: primitives.neutrals.stone['160'],
          disabled: primitives.neutrals.stone['180']
        },
        tonal: {
          superSoft: {
            default: primitives.semantic.info['160'],
            hover: primitives.semantic.info['120'],
            pressed: primitives.semantic.info['140'],
            dragged: primitives.semantic.info['120'],
            selected: primitives.semantic.info['90'],
            disabled: primitives.neutrals.stone['180'],
            focused: primitives.semantic.info['160'],
            inverse: primitives.semantic.info['05']
          },
          soft: {
            default: primitives.neutrals.stone['160'],
            inverse: primitives.neutrals.stone['100'],
            hover: primitives.neutrals.stone['180'],
            pressed: primitives.neutrals.stone['150'],
            dragged: primitives.neutrals.stone['180'],
            selected: primitives.neutrals.stone['100'],
            disabled: primitives.neutrals.stone['180']
          },
          medium: {
            default: primitives.neutrals.stone['155'],
            inverse: primitives.neutrals.stone['110'],
            hover: primitives.neutrals.stone['120'],
            pressed: primitives.neutrals.stone['150'],
            dragged: primitives.neutrals.stone['120'],
            selected: primitives.neutrals.white['100'],
            disabled: primitives.neutrals.stone['180']
          }
        }
      }
    }
  },
  foreground: {
    main: {
      primary: primitives.neutrals.white['100'],
      secondary: primitives.neutrals.stone['120'],
      disabled: primitives.neutrals.stone['155'],
      inverse: primitives.neutrals.alvieBlack['100'],
      link: primitives.main.alvieBlue['60'],
      linkInverse: primitives.main.alvieBlue['110'],
      interactive: primitives.main.alvieBlue['60'],
      staticWhite: primitives.neutrals.white['100'],
      staticBlack: primitives.neutrals.alvieBlack['100']
    },
    semantic: {
      neutral: {
        default: primitives.neutrals.white['100'],
        inverse: primitives.neutrals.stone['160']
      },
      info: {
        default: primitives.semantic.info['05'],
        tonal: {
          default: primitives.semantic.info['60'],
          inverse: primitives.semantic.info['120']
        },
        inverse: primitives.semantic.info['120']
      },
      success: {
        default: primitives.semantic.success['05'],
        tonal: {
          default: primitives.semantic.success['40'],
          inverse: primitives.semantic.success['140']
        },
        inverse: primitives.semantic.success['140']
      },
      warning: {
        default: primitives.semantic.warning['05'],
        tonal: {
          default: primitives.semantic.warning['60'],
          inverse: primitives.semantic.warning['140']
        },
        inverse: primitives.semantic.warning['140']
      },
      error: {
        default: primitives.semantic.error['05'],
        tonal: {
          default: primitives.semantic.error['40'],
          inverse: primitives.semantic.error['120']
        },
        inverse: primitives.semantic.error['120']
      }
    },
    brand: {
      default: primitives.main.alvieBlue['60'],
      inverse: primitives.main.alvieBlue['110']
    }
  },
  fill: {
    tonalMedium: primitives.neutrals.stone['160']
  },
  border: {
    main: {
      default: primitives.neutrals.stone['150'],
      tonal: primitives.neutrals.stone['160']
    },
    focus: {
      brand: {
        primary: primitives.main.alvieBlue['60'],
        haloSubtle: primitives.main.alvieBlue['120'],
        secondary: primitives.neutrals.alvieBlack['100'],
        halo: primitives.main.alvieBlue['60']
      }
    },
    error: {
      primary: primitives.semantic.error['100'],
      secondary: primitives.neutrals.alvieBlack['100'],
      halo: primitives.semantic.error['160']
    },
    success: {
      primary: primitives.semantic.success['100'],
      secondary: primitives.neutrals.alvieBlack['100'],
      halo: primitives.semantic.success['160']
    }
  },
  dataViz: {
    primary: {
      1: {
        fill: {
          default: primitives.main.alvieBlue['100'],
          hover: primitives.main.alvieBlue['90'],
          pressed: primitives.main.alvieBlue['110'],
          dragged: primitives.main.alvieBlue['90'],
          selected: primitives.main.alvieBlue['60'],
          focused: primitives.main.alvieBlue['100'],
          subtle: primitives.main.alvieBlue['110'],
          disabled: primitives.neutrals.stone['180'],
          muted: primitives.main.alvieBlue['30%'],
          tonal: {
            superSoft: {
              default: primitives.main.alvieBlue['160'],
              hover: primitives.main.alvieBlue['120'],
              pressed: primitives.main.alvieBlue['140'],
              dragged: primitives.main.alvieBlue['120'],
              selected: primitives.main.alvieBlue['90'],
              focused: primitives.main.alvieBlue['160'],
              disabled: primitives.neutrals.stone['180'],
              muted: primitives.main.alvieBlue['30%']
            },
            soft: {
              default: primitives.main.alvieBlue['140'],
              hover: primitives.main.alvieBlue['100'],
              pressed: primitives.main.alvieBlue['120'],
              dragged: primitives.main.alvieBlue['110'],
              selected: primitives.main.alvieBlue['60'],
              focused: primitives.main.alvieBlue['140'],
              disabled: primitives.neutrals.stone['180'],
              muted: primitives.main.alvieBlue['30%']
            }
          }
        },
        border: {
          default: primitives.main.alvieBlue['90'],
          subtle: primitives.main.alvieBlue['100'],
          halo: primitives.main.alvieBlue['120']
        }
      },
      2: {
        fill: {
          default: primitives.dataViz.teal['100'],
          tonal: {
            superSoft: {
              default: primitives.dataViz.teal['160'],
              hover: primitives.dataViz.teal['120'],
              pressed: primitives.dataViz.teal['140'],
              dragged: primitives.dataViz.teal['120'],
              selected: primitives.dataViz.teal['90'],
              focused: primitives.dataViz.teal['160'],
              disabled: primitives.neutrals.stone['180'],
              muted: primitives.dataViz.teal['30%']
            },
            soft: {
              default: primitives.dataViz.teal['140'],
              hover: primitives.dataViz.teal['100'],
              pressed: primitives.dataViz.teal['120'],
              dragged: primitives.dataViz.teal['110'],
              selected: primitives.dataViz.teal['50'],
              focused: primitives.dataViz.teal['140'],
              disabled: primitives.neutrals.stone['180'],
              muted: primitives.dataViz.teal['30%']
            }
          },
          hover: primitives.dataViz.teal['90'],
          pressed: primitives.dataViz.teal['110'],
          dragged: primitives.dataViz.teal['90'],
          selected: primitives.dataViz.teal['50'],
          focused: primitives.dataViz.teal['100'],
          disabled: primitives.neutrals.stone['180'],
          muted: primitives.dataViz.teal['30%'],
          subtle: primitives.dataViz.teal['110']
        },
        border: {
          default: primitives.dataViz.teal['90'],
          subtle: primitives.dataViz.teal['100']
        }
      },
      3: {
        fill: {
          default: primitives.dataViz.orange['100'],
          subtle: primitives.dataViz.orange['110'],
          hover: primitives.dataViz.orange['90'],
          pressed: primitives.dataViz.orange['110'],
          dragged: primitives.dataViz.orange['90'],
          selected: primitives.dataViz.orange['50'],
          focused: primitives.dataViz.orange['100'],
          disabled: primitives.neutrals.stone['180'],
          muted: primitives.dataViz.orange['30%'],
          tonal: {
            superSoft: {
              default: primitives.dataViz.orange['160'],
              hover: primitives.dataViz.orange['120'],
              pressed: primitives.dataViz.orange['140'],
              dragged: primitives.dataViz.orange['120'],
              selected: primitives.dataViz.orange['90'],
              focused: primitives.dataViz.orange['160'],
              disabled: primitives.neutrals.stone['180'],
              muted: primitives.dataViz.orange['30%']
            },
            soft: {
              default: primitives.dataViz.orange['140'],
              hover: primitives.dataViz.orange['100'],
              pressed: primitives.dataViz.orange['120'],
              dragged: primitives.dataViz.orange['110'],
              selected: primitives.dataViz.orange['50'],
              focused: primitives.dataViz.orange['140'],
              disabled: primitives.neutrals.stone['180'],
              muted: primitives.dataViz.orange['30%']
            }
          }
        },
        border: {
          default: primitives.dataViz.orange['90'],
          subtle: primitives.dataViz.orange['100']
        }
      },
      4: {
        fill: {
          default: primitives.dataViz.magneta['100'],
          hover: primitives.dataViz.magneta['90'],
          pressed: primitives.dataViz.magneta['110'],
          dragged: primitives.dataViz.magneta['90'],
          selected: primitives.dataViz.magneta['50'],
          focused: primitives.dataViz.magneta['100'],
          disabled: primitives.neutrals.stone['180'],
          tonal: {
            superSoft: {
              default: primitives.dataViz.magneta['160'],
              hover: primitives.dataViz.magneta['120'],
              pressed: primitives.dataViz.magneta['140'],
              dragged: primitives.dataViz.magneta['120'],
              selected: primitives.dataViz.magneta['90'],
              focused: primitives.dataViz.magneta['160'],
              disabled: primitives.neutrals.stone['180'],
              muted: primitives.dataViz.magneta['30%']
            },
            soft: {
              default: primitives.dataViz.magneta['140'],
              hover: primitives.dataViz.magneta['100'],
              pressed: primitives.dataViz.magneta['120'],
              dragged: primitives.dataViz.magneta['110'],
              selected: primitives.dataViz.magneta['50'],
              focused: primitives.dataViz.magneta['140'],
              disabled: primitives.neutrals.stone['180'],
              muted: primitives.dataViz.magneta['30%']
            }
          },
          subtle: primitives.dataViz.magneta['110'],
          muted: primitives.dataViz.magneta['30%']
        },
        border: {
          default: primitives.dataViz.magneta['90'],
          subtle: primitives.dataViz.magneta['100']
        }
      },
      5: {
        fill: {
          default: primitives.dataViz.violet['100'],
          hover: primitives.dataViz.violet['90'],
          pressed: primitives.dataViz.violet['110'],
          dragged: primitives.dataViz.violet['90'],
          selected: primitives.dataViz.violet['50'],
          focused: primitives.dataViz.violet['100'],
          disabled: primitives.neutrals.stone['180'],
          tonal: {
            superSoft: {
              default: primitives.dataViz.violet['160'],
              hover: primitives.dataViz.violet['120'],
              pressed: primitives.dataViz.violet['140'],
              dragged: primitives.dataViz.violet['120'],
              selected: primitives.dataViz.violet['90'],
              focused: primitives.dataViz.violet['160'],
              disabled: primitives.neutrals.stone['180'],
              muted: primitives.dataViz.violet['30%']
            },
            soft: {
              default: primitives.dataViz.violet['140'],
              hover: primitives.dataViz.violet['100'],
              pressed: primitives.dataViz.violet['120'],
              dragged: primitives.dataViz.violet['110'],
              selected: primitives.dataViz.violet['50'],
              focused: primitives.dataViz.violet['140'],
              disabled: primitives.neutrals.stone['180'],
              muted: primitives.dataViz.violet['30%']
            }
          },
          muted: primitives.dataViz.violet['30%'],
          subtle: primitives.dataViz.violet['110']
        },
        border: {
          default: primitives.dataViz.violet['90'],
          subtle: primitives.dataViz.violet['100']
        }
      },
      6: {
        fill: {
          default: primitives.dataViz.andesite['100'],
          hover: primitives.dataViz.andesite['90'],
          pressed: primitives.dataViz.andesite['110'],
          dragged: primitives.dataViz.andesite['90'],
          selected: primitives.dataViz.andesite['50'],
          focused: primitives.dataViz.andesite['100'],
          disabled: primitives.neutrals.stone['180'],
          tonal: {
            superSoft: {
              default: primitives.dataViz.andesite['160'],
              hover: primitives.dataViz.andesite['120'],
              pressed: primitives.dataViz.andesite['140'],
              dragged: primitives.dataViz.andesite['120'],
              selected: primitives.dataViz.andesite['90'],
              focused: primitives.dataViz.andesite['160'],
              disabled: primitives.neutrals.stone['180'],
              muted: primitives.dataViz.andesite['30%']
            },
            soft: {
              default: primitives.dataViz.andesite['140'],
              hover: primitives.dataViz.andesite['100'],
              pressed: primitives.dataViz.andesite['120'],
              dragged: primitives.dataViz.andesite['110'],
              selected: primitives.dataViz.andesite['50'],
              focused: primitives.dataViz.andesite['140'],
              disabled: primitives.neutrals.stone['180'],
              muted: primitives.dataViz.andesite['30%']
            }
          },
          muted: primitives.dataViz.andesite['30%'],
          subtle: primitives.dataViz.andesite['100']
        },
        border: {
          default: primitives.dataViz.andesite['50'],
          subtle: primitives.dataViz.andesite['90']
        }
      },
      7: {
        fill: {
          default: primitives.dataViz.cobalt['90'],
          hover: primitives.dataViz.cobalt['90'],
          pressed: primitives.dataViz.cobalt['110'],
          dragged: primitives.dataViz.cobalt['90'],
          selected: primitives.dataViz.cobalt['50'],
          focused: primitives.dataViz.cobalt['100'],
          disabled: primitives.neutrals.stone['180'],
          tonal: {
            superSoft: {
              default: primitives.dataViz.cobalt['160'],
              hover: primitives.dataViz.cobalt['120'],
              pressed: primitives.dataViz.cobalt['140'],
              dragged: primitives.dataViz.cobalt['120'],
              selected: primitives.dataViz.cobalt['90'],
              focused: primitives.dataViz.cobalt['160'],
              disabled: primitives.neutrals.stone['180'],
              muted: primitives.dataViz.cobalt['30%']
            },
            soft: {
              default: primitives.dataViz.cobalt['140'],
              hover: primitives.dataViz.cobalt['100'],
              pressed: primitives.dataViz.cobalt['120'],
              dragged: primitives.dataViz.cobalt['110'],
              selected: primitives.dataViz.cobalt['50'],
              focused: primitives.dataViz.cobalt['140'],
              disabled: primitives.neutrals.stone['180'],
              muted: primitives.dataViz.cobalt['30%']
            }
          },
          muted: primitives.dataViz.cobalt['30%'],
          subtle: primitives.dataViz.cobalt['100']
        },
        border: {
          default: primitives.dataViz.cobalt['50'],
          subtle: primitives.dataViz.cobalt['90']
        }
      },
      8: {
        fill: {
          default: primitives.dataViz.brown['90'],
          hover: primitives.dataViz.brown['90'],
          pressed: primitives.dataViz.brown['110'],
          dragged: primitives.dataViz.brown['90'],
          selected: primitives.dataViz.brown['50'],
          focused: primitives.dataViz.brown['100'],
          disabled: primitives.neutrals.stone['180'],
          tonal: {
            superSoft: {
              default: primitives.dataViz.brown['160'],
              hover: primitives.dataViz.brown['120'],
              pressed: primitives.dataViz.brown['140'],
              dragged: primitives.dataViz.brown['120'],
              selected: primitives.dataViz.brown['90'],
              focused: primitives.dataViz.brown['160'],
              disabled: primitives.neutrals.stone['180'],
              muted: primitives.dataViz.brown['30%']
            },
            soft: {
              default: primitives.dataViz.brown['140'],
              hover: primitives.dataViz.brown['100'],
              pressed: primitives.dataViz.brown['120'],
              dragged: primitives.dataViz.brown['110'],
              selected: primitives.dataViz.brown['50'],
              focused: primitives.dataViz.brown['140'],
              disabled: primitives.neutrals.stone['180'],
              muted: primitives.dataViz.brown['30%']
            }
          },
          muted: primitives.dataViz.brown['30%'],
          subtle: primitives.dataViz.brown['100']
        },
        border: {
          default: primitives.dataViz.brown['50'],
          subtle: primitives.dataViz.brown['90']
        }
      }
    },
    'primary-2': primitives.dataViz.teal['100'],
    'primary-8': primitives.dataViz.brown['90'],
    'secondary-8': primitives.dataViz.brass['100'],
    secondary: {
      1: {
        fill: {
          default: primitives.dataViz.pink['100'],
          hover: primitives.dataViz.pink['90'],
          pressed: primitives.dataViz.pink['110'],
          dragged: primitives.dataViz.pink['90'],
          selected: primitives.dataViz.pink['50'],
          focused: primitives.dataViz.pink['100'],
          disabled: primitives.neutrals.stone['180'],
          tonal: {
            superSoft: {
              default: primitives.dataViz.pink['160'],
              hover: primitives.dataViz.pink['120'],
              pressed: primitives.dataViz.pink['140'],
              dragged: primitives.dataViz.pink['120'],
              selected: primitives.dataViz.pink['90'],
              focused: primitives.dataViz.pink['160'],
              disabled: primitives.neutrals.stone['180'],
              muted: primitives.dataViz.pink['30%']
            },
            soft: {
              default: primitives.dataViz.pink['140'],
              hover: primitives.dataViz.pink['100'],
              pressed: primitives.dataViz.pink['120'],
              dragged: primitives.dataViz.pink['110'],
              selected: primitives.dataViz.pink['50'],
              focused: primitives.dataViz.pink['140'],
              disabled: primitives.neutrals.stone['180'],
              muted: primitives.dataViz.pink['30%']
            }
          },
          muted: primitives.dataViz.pink['30%'],
          subtle: primitives.dataViz.pink['110']
        },
        border: {
          default: primitives.dataViz.pink['90'],
          subtle: primitives.dataViz.pink['100'],
          halo: primitives.dataViz.pink['110']
        }
      },
      2: {
        fill: {
          default: primitives.dataViz.olive['100'],
          hover: primitives.dataViz.olive['90'],
          pressed: primitives.dataViz.olive['110'],
          dragged: primitives.dataViz.olive['90'],
          selected: primitives.dataViz.olive['50'],
          focused: primitives.dataViz.olive['100'],
          disabled: primitives.neutrals.stone['180'],
          tonal: {
            superSoft: {
              default: primitives.dataViz.olive['160'],
              hover: primitives.dataViz.olive['120'],
              pressed: primitives.dataViz.olive['140'],
              dragged: primitives.dataViz.olive['120'],
              selected: primitives.dataViz.olive['90'],
              focused: primitives.dataViz.olive['160'],
              disabled: primitives.neutrals.stone['180'],
              muted: primitives.dataViz.olive['30%']
            },
            soft: {
              default: primitives.dataViz.olive['140'],
              hover: primitives.dataViz.olive['100'],
              pressed: primitives.dataViz.olive['120'],
              dragged: primitives.dataViz.olive['110'],
              selected: primitives.dataViz.olive['50'],
              focused: primitives.dataViz.olive['140'],
              disabled: primitives.neutrals.stone['180'],
              muted: primitives.dataViz.olive['30%']
            }
          },
          muted: primitives.dataViz.olive['30%'],
          subtle: primitives.dataViz.olive['110']
        },
        border: {
          default: primitives.dataViz.olive['90'],
          subtle: primitives.dataViz.olive['100']
        }
      },
      3: {
        fill: {
          default: primitives.dataViz.sienna['100'],
          hover: primitives.dataViz.sienna['90'],
          pressed: primitives.dataViz.sienna['110'],
          dragged: primitives.dataViz.sienna['90'],
          selected: primitives.dataViz.sienna['50'],
          focused: primitives.dataViz.sienna['100'],
          disabled: primitives.neutrals.stone['180'],
          tonal: {
            superSoft: {
              default: primitives.dataViz.sienna['160'],
              hover: primitives.dataViz.sienna['120'],
              pressed: primitives.dataViz.sienna['140'],
              dragged: primitives.dataViz.sienna['120'],
              selected: primitives.dataViz.sienna['90'],
              focused: primitives.dataViz.sienna['160'],
              disabled: primitives.neutrals.stone['180'],
              muted: primitives.dataViz.sienna['30%']
            },
            soft: {
              default: primitives.dataViz.sienna['140'],
              hover: primitives.dataViz.sienna['100'],
              pressed: primitives.dataViz.sienna['120'],
              dragged: primitives.dataViz.sienna['110'],
              selected: primitives.dataViz.sienna['50'],
              focused: primitives.dataViz.sienna['140'],
              disabled: primitives.neutrals.stone['180'],
              muted: primitives.dataViz.sienna['30%']
            }
          },
          muted: primitives.dataViz.sienna['30%']
        },
        border: {
          default: primitives.dataViz.sienna['90'],
          subtle: primitives.dataViz.sienna['100']
        }
      },
      4: {
        fill: {
          default: primitives.dataViz.green['100'],
          hover: primitives.dataViz.green['90'],
          pressed: primitives.dataViz.green['110'],
          dragged: primitives.dataViz.green['90'],
          selected: primitives.dataViz.green['50'],
          focused: primitives.dataViz.green['100'],
          disabled: primitives.neutrals.stone['180'],
          tonal: {
            superSoft: {
              default: primitives.dataViz.green['160'],
              hover: primitives.dataViz.green['120'],
              pressed: primitives.dataViz.green['140'],
              dragged: primitives.dataViz.green['120'],
              selected: primitives.dataViz.green['90'],
              focused: primitives.dataViz.green['160'],
              disabled: primitives.neutrals.stone['180'],
              muted: primitives.dataViz.green['30%']
            },
            soft: {
              default: primitives.dataViz.green['140'],
              hover: primitives.dataViz.green['100'],
              pressed: primitives.dataViz.green['120'],
              dragged: primitives.dataViz.green['110'],
              selected: primitives.dataViz.green['50'],
              focused: primitives.dataViz.green['140'],
              disabled: primitives.neutrals.stone['180'],
              muted: primitives.dataViz.green['30%']
            }
          },
          muted: primitives.dataViz.green['30%']
        },
        border: {
          default: primitives.dataViz.green['50'],
          subtle: primitives.dataViz.green['90']
        }
      },
      5: {
        fill: {
          default: primitives.dataViz.caramel['100'],
          hover: primitives.dataViz.caramel['90'],
          pressed: primitives.dataViz.caramel['110'],
          dragged: primitives.dataViz.caramel['90'],
          selected: primitives.dataViz.caramel['50'],
          focused: primitives.dataViz.caramel['100'],
          disabled: primitives.neutrals.stone['180'],
          tonal: {
            superSoft: {
              default: primitives.dataViz.caramel['160'],
              hover: primitives.dataViz.caramel['120'],
              pressed: primitives.dataViz.caramel['140'],
              dragged: primitives.dataViz.caramel['120'],
              selected: primitives.dataViz.caramel['90'],
              focused: primitives.dataViz.caramel['160'],
              disabled: primitives.neutrals.stone['180'],
              muted: primitives.dataViz.caramel['30%']
            },
            soft: {
              default: primitives.dataViz.caramel['140'],
              hover: primitives.dataViz.caramel['100'],
              pressed: primitives.dataViz.caramel['120'],
              dragged: primitives.dataViz.caramel['110'],
              selected: primitives.dataViz.caramel['50'],
              focused: primitives.dataViz.caramel['140'],
              disabled: primitives.neutrals.stone['180'],
              muted: primitives.dataViz.caramel['30%']
            }
          },
          muted: primitives.dataViz.caramel['30%']
        },
        border: {
          default: primitives.dataViz.caramel['90'],
          subtle: primitives.dataViz.caramel['100']
        }
      },
      6: {
        fill: {
          default: primitives.dataViz.aqua['100'],
          hover: primitives.dataViz.aqua['90'],
          pressed: primitives.dataViz.aqua['110'],
          dragged: primitives.dataViz.aqua['90'],
          selected: primitives.dataViz.aqua['50'],
          focused: primitives.dataViz.aqua['100'],
          disabled: primitives.neutrals.stone['180'],
          muted: primitives.dataViz.aqua['30%'],
          tonal: {
            superSoft: {
              default: primitives.dataViz.aqua['160'],
              hover: primitives.dataViz.aqua['120'],
              pressed: primitives.dataViz.aqua['140'],
              dragged: primitives.dataViz.aqua['120'],
              selected: primitives.dataViz.aqua['90'],
              focused: primitives.dataViz.aqua['160'],
              disabled: primitives.neutrals.stone['180'],
              muted: primitives.dataViz.aqua['30%']
            },
            soft: {
              default: primitives.dataViz.aqua['140'],
              hover: primitives.dataViz.aqua['100'],
              pressed: primitives.dataViz.aqua['120'],
              dragged: primitives.dataViz.aqua['110'],
              selected: primitives.dataViz.aqua['50'],
              focused: primitives.dataViz.aqua['140'],
              disabled: primitives.neutrals.stone['180'],
              muted: primitives.dataViz.aqua['30%']
            }
          }
        },
        border: {
          default: primitives.dataViz.aqua['90'],
          subtle: primitives.dataViz.aqua['100']
        }
      },
      7: {
        fill: {
          default: primitives.dataViz.salmon['100'],
          hover: primitives.dataViz.salmon['90'],
          pressed: primitives.dataViz.salmon['110'],
          dragged: primitives.dataViz.salmon['90'],
          selected: primitives.dataViz.salmon['50'],
          focused: primitives.dataViz.salmon['100'],
          disabled: primitives.neutrals.stone['180'],
          muted: primitives.dataViz.salmon['30%'],
          tonal: {
            superSoft: {
              default: primitives.dataViz.salmon['160'],
              hover: primitives.dataViz.salmon['120'],
              pressed: primitives.dataViz.salmon['140'],
              dragged: primitives.dataViz.salmon['120'],
              selected: primitives.dataViz.salmon['90'],
              focused: primitives.dataViz.salmon['160'],
              disabled: primitives.neutrals.stone['180'],
              muted: primitives.dataViz.salmon['30%']
            },
            soft: {
              default: primitives.dataViz.salmon['140'],
              hover: primitives.dataViz.salmon['100'],
              pressed: primitives.dataViz.salmon['120'],
              dragged: primitives.dataViz.salmon['110'],
              selected: primitives.dataViz.salmon['50'],
              focused: primitives.dataViz.salmon['140'],
              disabled: primitives.neutrals.stone['180'],
              muted: primitives.dataViz.salmon['30%']
            }
          }
        },
        border: {
          default: primitives.dataViz.salmon['90'],
          subtle: primitives.dataViz.salmon['100']
        }
      },
      8: {
        fill: {
          default: primitives.dataViz.brass['100'],
          hover: primitives.dataViz.brass['90'],
          pressed: primitives.dataViz.brass['110'],
          dragged: primitives.dataViz.brass['90'],
          selected: primitives.dataViz.brass['50'],
          focused: primitives.dataViz.brass['100'],
          disabled: primitives.neutrals.stone['180'],
          tonal: {
            superSoft: {
              default: primitives.dataViz.brass['160'],
              hover: primitives.dataViz.brass['120'],
              pressed: primitives.dataViz.brass['140'],
              dragged: primitives.dataViz.brass['120'],
              selected: primitives.dataViz.brass['90'],
              focused: primitives.dataViz.brass['160'],
              disabled: primitives.neutrals.stone['180'],
              muted: primitives.dataViz.brass['30%']
            },
            soft: {
              default: primitives.dataViz.brass['140'],
              hover: primitives.dataViz.brass['100'],
              pressed: primitives.dataViz.brass['120'],
              dragged: primitives.dataViz.brass['110'],
              selected: primitives.dataViz.brass['50'],
              focused: primitives.dataViz.brass['140'],
              disabled: primitives.neutrals.stone['180'],
              muted: primitives.dataViz.brass['30%']
            }
          },
          muted: primitives.dataViz.brass['30%']
        },
        border: {
          default: primitives.dataViz.brass['90'],
          subtle: primitives.dataViz.brass['100']
        }
      }
    },
    semantic: {
      info: {
        fill: {
          default: primitives.semantic.info['100'],
          disabled: primitives.semantic.info['30%']
        },
        border: {
          default: primitives.semantic.info['90'],
          halo: primitives.semantic.info['110']
        }
      },
      success: {
        fill: {
          default: primitives.semantic.success['100'],
          disabled: primitives.semantic.success['30%']
        },
        border: {
          default: primitives.semantic.success['90']
        }
      },
      warning: {
        fill: {
          default: primitives.semantic.warning['100'],
          disabled: primitives.semantic.warning['30%']
        },
        border: {
          default: primitives.semantic.warning['90']
        }
      },
      error: {
        fill: {
          default: primitives.semantic.error['100'],
          disabled: primitives.semantic.error['30%']
        },
        border: {
          default: primitives.semantic.error['90']
        }
      }
    }
  }
} as const satisfies SemanticTokens
